// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"a635b4c8","558":"52c9cd1d","715":"cfe3e5ab","740":"e25f1de6","810":"4055b2c6"}[chunkId] + ".chunk.css";
};